module.exports = __webpack_public_path__ + "static/media/yonggan.c540b2ec.png";